import { Button } from '@mui/material';
import React from 'react';
import './ButtonComponentBox.scss';

const ButtonComponentBox = (props) => {
  const { componentObj, onClickComponent, componentNdx, isPreview, onClickRedirectLink } = props;
  const onComponentClick = () => {
    componentObj.index = componentNdx;
    componentObj.selected = true;
    onClickComponent(componentObj, componentNdx);
  };

  return (
    <div
      className={`card layout-card body-button-layout col-md-12 ${
        !isPreview && componentObj.selected ? 'layout-card-selected' : ''
      }`}
      onClick={() => onComponentClick()}
      style={{
        backgroundColor: componentObj?.hexCode || '#82828214',
      }}
    >
      <Button
        className='custom-button'
        style={{
          padding: componentObj?.padding
            ? `${componentObj?.top || 0}px ${componentObj?.right || 0}px ${
                componentObj?.bottom || 0
              }px ${componentObj?.left || 0}px`
            : '10px',
          backgroundColor: componentObj?.buttonColor || '#828282',
        }}
        onClick={() => onClickRedirectLink(componentObj?.url)}
      >
        {componentObj?.text || 'ADD TEXT HERE'}
      </Button>
    </div>
  );
};

export default ButtonComponentBox;
